export default __webpack_public_path__ + "static/media/college_collab_mob.c16adbb2.png";